<template>
  <div
    v-if="appVersion"
    class="app-version text-v-ui-text-monochrome-55 note-12-reg-400"
  >
    Версия платформы {{ appVersion }}
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
      version: null,
    };
  },
  computed: {
    ...mapState('Other', ['appVersion']),
  },
};
</script>

<style lang="scss" scoped>
  .app-version {
    padding-top: 16px;
    padding-bottom: 12px;
    display: flex;
    justify-content: center;
    width: 100%;
    overflow: hidden;
    background: transparent;
  }
</style>
